import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Mumbaitogoaonewaycab() {



    const cardData = {

keyword: "Mumbai to Goa One Way Cab",

headingDescription:
    "Mumbai Airport Cab offers reliable and affordable Mumbai to Goa One Way Cab services for solo travel, family trips, group tours, business travel, and holiday vacations. We provide a wide range of well-maintained vehicles including Sedan, SUV, Innova Crysta, Ertiga, Kia Carens, Tempo Traveller, Luxury Urbania, and Mini Bus with professional and experienced chauffeurs. With 24x7 availability, transparent pricing, doorstep pickup across Mumbai, and safe highway driving via the Mumbai–Goa route, we ensure a smooth, comfortable, and hassle-free one-way journey to Goa at the best price.",

topPlaces: [
    {
        title: "Baga Beach",
        description:
            "Baga Beach is one of Goa’s most famous beaches, known for its vibrant nightlife, water sports activities, beach shacks, and energetic tourist crowd throughout the year."
    },
    {
        title: "Calangute Beach",
        description:
            "Calangute Beach is often called the Queen of Beaches and is popular for its long coastline, shopping stalls, water sports, and lively atmosphere for tourists."
    },
    {
        title: "Anjuna Beach",
        description:
            "Anjuna Beach is famous for its rocky coastline, flea market, sunset views, and relaxed bohemian vibe attracting both Indian and international travelers."
    },
    {
        title: "Fort Aguada",
        description:
            "Fort Aguada is a well-preserved Portuguese fort offering panoramic sea views, a historic lighthouse, and a glimpse into Goa’s colonial past."
    },
    {
        title: "Dudhsagar Waterfalls",
        description:
            "Dudhsagar Waterfalls is one of India’s tallest waterfalls, located on the Goa-Karnataka border, known for its milky white cascade and dense forest surroundings."
    },
    {
        title: "Basilica of Bom Jesus",
        description:
            "Basilica of Bom Jesus is a UNESCO World Heritage Site in Old Goa, famous for its baroque architecture and the preserved mortal remains of St. Francis Xavier."
    },
    {
        title: "Palolem Beach",
        description:
            "Palolem Beach in South Goa is known for its calm waters, scenic beauty, beach huts, and peaceful atmosphere ideal for relaxing vacations."
    },
    {
        title: "Chapora Fort",
        description:
            "Chapora Fort is a popular viewpoint overlooking Vagator Beach, famous for its sunset views and its appearance in Bollywood movies."
    },
    {
        title: "Candolim Beach",
        description:
            "Candolim Beach is a less crowded North Goa beach known for clean shores, water sports, and a peaceful environment ideal for family relaxation."
    },
    {
        title: "Se Cathedral",
        description:
            "Se Cathedral is one of the largest churches in Asia, known for its Portuguese-Gothic architecture and deep historical and religious significance in Old Goa."
    }
],



services: [
{
name: "Mumbai to Goa One Way Cab",
description: "Mumbai to Goa One Way Cab service by 1Touch Cabs provides safe, affordable, and comfortable long-distance travel for passengers heading from Mumbai to Goa without return fare charges. Our service is designed for tourists, families, corporate travelers, and solo passengers looking for a hassle-free one-way journey. We offer a wide range of well-maintained vehicles including Sedan, Swift Dzire, Ertiga, Kia Carens, Innova, Innova Crysta, SUV, Luxury Cars, and Tempo Traveller options. With experienced chauffeurs, smooth highway driving via the Mumbai–Goa route, doorstep pickup, luggage assistance, and 24x7 booking support, we ensure a reliable and stress-free travel experience.",
},
{
name: "Mumbai to Goa One Way Taxi",
description: "Mumbai to Goa One Way Taxi service offers convenient and budget-friendly transportation for travelers who only need a single-side journey. 1Touch Cabs provides clean AC vehicles, professional drivers, and flexible pickup options for a smooth intercity travel experience.",
},
{
name: "Mumbai to Goa Taxi One Way Fare",
description: "Mumbai to Goa Taxi One Way Fare service ensures transparent and competitive pricing with no hidden charges. 1Touch Cabs offers affordable fare options for Sedan, SUV, Innova, and premium vehicles for one-way travel from Mumbai to Goa.",
},
{
name: "Mumbai to Goa Cab Service",
description: "Mumbai to Goa Cab Service provides reliable and comfortable outstation travel with professional chauffeurs and well-maintained vehicles. 1Touch Cabs ensures safe journeys, timely pickups, and smooth highway rides for all passengers.",
},
{
name: "Mumbai to Goa Taxi Service",
description: "Mumbai to Goa Taxi Service offers dependable long-distance transportation with experienced drivers, clean vehicles, and 24x7 availability. 1Touch Cabs ensures a comfortable and safe journey for families and tourists.",
},
{
name: "Mumbai to Goa Outstation Cab",
description: "Mumbai to Goa Outstation Cab service is ideal for long-distance travelers seeking safe, comfortable, and affordable transportation. 1Touch Cabs provides multiple vehicle options and professional chauffeurs for a smooth road trip.",
},
{
name: "Mumbai to Goa Drop Taxi",
description: "Mumbai to Goa Drop Taxi service provides direct point-to-point travel without return charges. 1Touch Cabs ensures budget-friendly pricing, safe driving, and convenient door-to-door service.",
},
{
name: "Mumbai to Goa Private Cab",
description: "Mumbai to Goa Private Cab service offers exclusive transportation with dedicated vehicles and personalized travel schedules. 1Touch Cabs ensures privacy, comfort, and flexibility for all passengers.",
},
{
name: "Mumbai to Goa AC Cab Service",
description: "Mumbai to Goa AC Cab Service provides fully air-conditioned, clean, and comfortable vehicles for long highway journeys. 1Touch Cabs ensures a smooth and pleasant travel experience.",
},
{
name: "Mumbai to Goa Cab Booking",
description: "Mumbai to Goa Cab Booking service allows easy online reservations with instant confirmation. 1Touch Cabs offers multiple vehicle choices, transparent pricing, and 24x7 booking support.",
},
{
name: "Mumbai to Goa Tourist Taxi",
description: "Mumbai to Goa Tourist Taxi service is designed for leisure travelers exploring Goa. 1Touch Cabs provides comfortable vehicles, experienced drivers, and flexible travel schedules for sightseeing trips.",
},
{
name: "Best Mumbai to Goa One Way Cab",
description: "Best Mumbai to Goa One Way Cab service by 1Touch Cabs ensures reliable, safe, and affordable travel with professional chauffeurs, clean vehicles, and excellent customer support.",
},
{
name: "Cheap Mumbai to Goa Taxi Service",
description: "Cheap Mumbai to Goa Taxi Service offers budget-friendly travel without compromising comfort or safety. 1Touch Cabs provides economical fares and reliable vehicles for all passengers.",
},
{
name: "Online Mumbai to Goa Cab Booking",
description: "Online Mumbai to Goa Cab Booking allows quick and easy reservation with instant confirmation. 1Touch Cabs offers flexible scheduling, multiple vehicle options, and 24x7 support.",
},
{
name: "Mumbai to Goa Family Cab",
description: "Mumbai to Goa Family Cab service ensures safe and comfortable travel for families with spacious vehicles, professional chauffeurs, and smooth highway journeys.",
},
{
name: "Mumbai to Goa Luxury Taxi",
description: "Mumbai to Goa Luxury Taxi service offers premium travel experience with high-end vehicles, professional chauffeurs, and superior comfort for VIP and corporate travelers.",
},
{
name: "Reliable Mumbai to Goa Cab",
description: "Reliable Mumbai to Goa Cab service ensures safe, punctual, and comfortable long-distance travel with experienced drivers and well-maintained vehicles.",
},
{
name: "Affordable Mumbai to Goa One Way Taxi",
description: "Affordable Mumbai to Goa One Way Taxi service provides cost-effective transportation solutions without return fare charges, ensuring budget-friendly travel with comfort.",
},
{
name: "Mumbai Airport to Goa Airport One Way Cab",
description: "Mumbai Airport to Goa Airport One Way Cab service provides direct airport-to-airport transportation with professional chauffeurs, luggage assistance, and smooth long-distance travel.",
},
{
name: "Mumbai Airport to Goa Airport Taxi",
description: "Mumbai Airport to Goa Airport Taxi service ensures safe and reliable inter-airport travel with clean vehicles, punctual pickups, and experienced drivers.",
},
{
name: "Mumbai Airport to Goa Airport Cab Service",
description: "Mumbai Airport to Goa Airport Cab Service offers comfortable long-distance airport transfers with professional chauffeurs and 24x7 availability.",
},
{
name: "Mumbai Airport to Goa Airport Transfer Cab",
description: "Mumbai Airport to Goa Airport Transfer Cab service provides seamless airport-to-airport transportation with door-to-door pickup and drop service.",
},
{
name: "Mumbai Airport to Goa Airport Drop Taxi",
description: "Mumbai Airport to Goa Airport Drop Taxi service ensures convenient and affordable airport transfer with safe driving and timely arrival."
}
],

tableData: [
["Mumbai to Goa One Way Cab","Mumbai to Goa One Way Taxi"],
["Mumbai to Goa Cab Service","Mumbai to Goa Taxi Service"],
["Mumbai to Goa Outstation Cab","Mumbai to Goa Drop Taxi"],
["Mumbai to Goa Private Cab","Mumbai to Goa AC Cab Service"],
["Mumbai to Goa Cab Booking","Mumbai to Goa Tourist Taxi"],
["Best Mumbai to Goa One Way Cab","Cheap Mumbai to Goa Taxi Service"],
["Online Mumbai to Goa Cab Booking","Mumbai to Goa One Side Taxi"],
["Mumbai to Goa One Way Car Rental","24x7 Mumbai to Goa Cab Service"],
["Mumbai to Goa Family Cab","Mumbai to Goa Luxury Taxi"],
["Reliable Mumbai to Goa Cab","Affordable Mumbai to Goa One Way Taxi"]
],
















whychoose: [
    {
        WhyChooseheading: "Reliable Mumbai to Goa One Way Cab Service",
        WhyChoosedescription: "Mumbai Airport Cabs provides dependable Mumbai to Goa One Way Cab services for tourists, families, couples, business travelers, and vacationers seeking comfortable long-distance transportation."
    },
    {
        WhyChooseheading: "Convenient One-Way Travel Solution",
        WhyChoosedescription: "Enjoy hassle-free one-way transportation from Mumbai to Goa without worrying about return travel charges, making your journey economical and convenient."
    },
    {
        WhyChooseheading: "Perfect for Holidays and Beach Vacations",
        WhyChoosedescription: "Goa is one of India's most loved holiday destinations, attracting travelers for beaches, nightlife, water sports, sightseeing, luxury resorts, and family vacations."
    },
    {
        WhyChooseheading: "Wide Range of Vehicle Options",
        WhyChoosedescription: "Customers can choose Sedan cars, Ertiga, Innova, Innova Crysta, Kia Carens, SUVs, Tempo Travellers, Mini Buses, and premium vehicles according to passenger count and luggage requirements."
    },
    {
        WhyChooseheading: "Flexible Pickup Across Mumbai",
        WhyChoosedescription: "Doorstep pickup services are available from Mumbai Airport, Navi Mumbai, Thane, Dombivli, Kalyan, Andheri, Borivali, Bandra, Dadar, Powai, and nearby locations."
    },
    {
        WhyChooseheading: "Comfortable Long-Distance Journey",
        WhyChoosedescription: "Travel comfortably through scenic highways and coastal routes with clean vehicles, spacious seating, and professional chauffeurs."
    },
    {
        WhyChooseheading: "Experienced Drivers for Goa Routes",
        WhyChoosedescription: "Our trained drivers are experienced on Mumbai-Goa routes and ensure safe driving, route expertise, and a smooth travel experience."
    },
    {
        WhyChooseheading: "Ideal for Families, Couples, and Tourist Groups",
        WhyChoosedescription: "From honeymoon couples and family vacationers to friends' groups and corporate travelers, we provide suitable vehicles for every Goa travel requirement."
    }
]
};

const faqData = [
    {
        question: "What is Mumbai to Goa One Way Cab Service?",
        answer: "It is a transportation service that allows customers to travel from Mumbai to Goa without booking a return journey."
    }, 
    {
        question: "Can I book a one-way cab from Mumbai to Goa anytime?",
        answer: "Yes, one-way cab services are available throughout the year based on vehicle availability and travel schedules."
    },
    {
        question: "Which vehicle is suitable for Mumbai to Goa one-way travel?",
        answer: "Sedan cars, Ertiga, Innova, Innova Crysta, Kia Carens, SUVs, Tempo Travellers, and Mini Buses are available according to passenger count and luggage requirements."
    },
    {
        question: "Can families book one-way cabs for Goa vacations?",
        answer: "Yes, many families prefer one-way cab services for comfortable travel directly to Goa hotels, resorts, villas, and holiday destinations."
    },
    {
        question: "Are Tempo Travellers available for group travel?",
        answer: "Yes, Tempo Travellers and Mini Buses are available for family groups, corporate outings, bachelor trips, and tourist groups."
    },
    {
        question: "Can pickup be arranged from Mumbai Airport?",
        answer: "Yes, pickup services are available from Mumbai Airport, hotels, railway stations, offices, and residential locations."
    },
    {
        question: "Can I customize my travel route?",
        answer: "Yes, customers can request customized routes, sightseeing stops, meal breaks, and preferred travel schedules."
    },
    {
        question: "Do you provide doorstep drop anywhere in Goa?",
        answer: "Yes, drop services are available across North Goa, South Goa, hotels, resorts, villas, beaches, and tourist destinations."
    },
    {
        question: "Is advance booking recommended for Mumbai to Goa one-way travel?",
        answer: "Yes, advance booking is recommended, especially during weekends, long holidays, Christmas, New Year, and peak tourist seasons."
    },
    {
        question: "How can I book a Mumbai to Goa One Way Cab?",
        answer: "Bookings can be made through phone calls, WhatsApp messages, or online inquiries with Mumbai Airport Cabs."
    }
];

const testimonials = [
    {
        id: 1,
        name: "Mr. Akshay Joshi",
        feedback:
            "We booked a one-way cab from Mumbai to Goa for our vacation. The vehicle was comfortable, the driver was courteous, and the journey was smooth throughout.",
        rating: 5
    },
    {
        id: 2,
        name: "Mrs. Radhika Mehta",
        feedback:
            "Our direct trip to Goa was perfectly organized. The cab arrived on time, the vehicle was clean, and the entire travel experience exceeded our expectations.",
        rating: 5
    }
];


















   const Images = [
    { place: "/images/keyword/114.jpg", text: "Mumbai Outstation Cabs", link: "Mumbai-Outstation-Cabs" },
    { place: "/images/keyword/113.jpg", text: "Mumbai to Mahabaleshwar Cab", link: "Mumbai-to-Mahabaleshwar-Cab" },
    { place: "/images/keyword/112.jpg", text: "Mumbai to Goa Cabs", link: "Mumbai-to-Goa-Cabs" },
    { place: "/images/keyword/111.jpg", text: "Mumbai to Shirdi Cab", link: "Mumbai-to-Shirdi-Cab" },
    { place: "/images/keyword/110.jpg", text: "Mumbai Nashik Cab", link: "Mumbai-Nashik-Cab" },
    { place: "/images/keyword/109.jpg", text: "Mumbai to Kolhapur Cab", link: "Mumbai-to-Kolhapur-Cab" },
    { place: "/images/keyword/108.jpg", text: "Mumbai to Pune Cab", link: "Mumbai-to-Pune-Cab" },
    { place: "/images/keyword/107.jpg", text: "Mumbai to Aurangabad Cab", link: "Mumbai-to-Aurangabad-Cab" },
    { place: "/images/keyword/106.jpg", text: "Mumbai to Bhimashankar Cab", link: "Mumbai-to-Bhimashankar-Cab" },
    { place: "/images/keyword/105.jpg", text: "Mumbai to Ashtavinayak Cab Service", link: "Mumbai-to-Ashtavinayak-Cab-Service" },
    { place: "/images/keyword/104.jpg", text: "Mumbai to 5 Jyotirlinga Cab", link: "Mumbai-to-5-Jyotirlinga-Cab" },
    { place: "/images/keyword/103.jpg", text: "Mumbai to Lonavala Cab", link: "Mumbai-to-Lonavala-Cab" },
    { place: "/images/keyword/102.jpg", text: "Mumbai to Konkan Darshan Cab Booking", link: "Mumbai-to-Konkan-Darshan-Cab-Booking" },
    { place: "/images/keyword/101.jpg", text: "Mumbai to Alibaug Cab", link: "Mumbai-to-Alibaug-Cab" },
    { place: "/images/keyword/100.jpg", text: "Mumbai to Ahmednagar Cab", link: "Mumbai-to-Ahmednagar-Cab" },
    { place: "/images/keyword/99.jpg", text: "Mumbai to Matheran Cab", link: "Mumbai-to-Matheran-Cab" },
    { place: "/images/keyword/98.jpg", text: "Mumbai to Jalgaon Cab Booking / Dhule", link: "Mumbai-to-Jalgaon-Dhule-Cab-Booking" },
    { place: "/images/keyword/97.jpg", text: "Mumbai to Lavasa Cab", link: "Mumbai-to-Lavasa-Cab" },
    { place: "/images/keyword/96.jpg", text: "Mumbai to Panchgani Cab", link: "Mumbai-to-Panchgani-Cab" },
    { place: "/images/keyword/95.jpg", text: "Mumbai to Khandala Taxi Fare", link: "Mumbai-to-Khandala-Taxi-Fare" },
    { place: "/images/keyword/94.jpg", text: "Mumbai to Surat Cab", link: "Mumbai-to-Surat-Cab" },
    { place: "/images/keyword/93.jpg", text: "Mumbai to Ahmedabad Cab", link: "Mumbai-to-Ahmedabad-Cab" },
    { place: "/images/keyword/92.jpg", text: "Mumbai to Narmada Parikrama Cab Booking", link: "Mumbai-to-Narmada-Parikrama-Cab-Booking" },
    { place: "/images/keyword/91.jpg", text: "Mumbai to Baroda Cabs", link: "Mumbai-to-Baroda-Cabs" },
    { place: "/images/keyword/90.jpg", text: "Mumbai to Daman Taxi", link: "Mumbai-to-Daman-Taxi" },
];













const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Mumbai to Goa One Way Cab Service",
  "image": "https://www.mumbaiairportcabs.com/assets/images/mumbai-to-goa-one-way-cab.jpg",
  "description": "Book Mumbai to Goa one way cab service for safe, comfortable, and affordable outstation travel. Mumbai Airport Cabs offers reliable one-way taxi service with professional drivers, clean AC vehicles, and 24x7 availability for Goa drop trips.",
  "brand": {
    "@type": "Brand",
    "name": "Mumbai Airport Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "9500"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "Starting From ₹10,999",
    "availability": "https://schema.org/InStock",
    "url": "https://www.mumbaiairportcabs.com/mumbai-to-goa-one-way-cab"
  }
};



    return (
        <div>




<Helmet>
  <title>Mumbai to Goa One Way Cab | Drop Taxi Service | +91 9545731161</title>

  <meta
    name="description"
    content="Book Mumbai to Goa one way cab service for safe and affordable travel. Reliable drop taxi with professional drivers and 24x7 booking support."
  />

  <meta
    name="keywords"
    content="mumbai to goa one way cab, mumbai to goa taxi one way fare, mumbai to goa one way taxi, Mumbai to Goa One Way Cab, Mumbai to Goa One Way Taxi, Mumbai to Goa Cab Service, Mumbai to Goa Taxi Service, Mumbai to Goa Outstation Cab, Mumbai to Goa Drop"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>






            <div
                className="breadcumb-wrapper"
                style={{
                    backgroundImage: "url('/images/breadcumb/breadcumb-bg.jpg')",
                    backgroundSize: "cover",
                    backgroundPosition: "center",
                }}
            >
                <div className="container z-index-common">
                    <div className="breadcumb-content">
                        <h1 className="breadcumb-title">{cardData.keyword}</h1>
                    </div>
                </div>
            </div>


















            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/7.jpg' alt='img' className='img-fluid' />
                            <h3 className="py-1"
                                style={{
                                    color: '#1A4160', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >Mumbai Airport Cab: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="topPlaces">

                                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard borderr" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>

                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>


                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div key={index} className="service-row">
                                        {/* <div className="service-icon">
                      🚗
                    </div> */}
                                        <div>
                                            <h4 className="service-title">{service.name}</h4>
                                            <p className="service-desc">{service.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>


                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section" className="why-choose-section">


                                {/* Section Title */}
                                <h2 className="section-title text-white">
                                    Why Choose <span>Mumbai Airport Cabs</span>
                                </h2>


                                {/* Cards */}
                                <div className="cards-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div key={index} className="why-card">
                                            <div className="icon-circle">{index + 1}</div>
                                            <h4 className="card-heading">{item.WhyChooseheading}</h4>
                                            <p className="card-desc">{item.WhyChoosedescription}</p>
                                        </div>
                                    ))}
                                </div>
                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Mumbai Airport Cabs </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title=""
                                                    subtitle=""
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase keyword={cardData.keyword} />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-telephone-fill"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+919545731161" className="pc-call">+91 9545731161</a>
                                        </div>

                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/919545731161"
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp"></i> WhatsApp
                                            </a>
                                            <a href="tel:+919545731161" className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-envelope-fill"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@mumbaiairportcabs.com" className="pc-email">
                                            booking@mumbaiairportcabs.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-geo-alt-fill"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Mumbai Airport Cabs</strong><br />

                                            SAWANT SADAN 05 Ramachandra cold drinks House,
                                            Near SBI Bank Nehru Road Opp Noble Medical,
                                            Vile Parle East Mumbai, 400057
                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Mumbaitogoaonewaycab;